export default __webpack_public_path__ + "static/ic_webinar_fido-ff31874c364131f2bbacd8cf159cca31.svg";